import { useQuery } from 'react-query';
import { trackPromise } from 'react-promise-tracker';
import { getMigratorInfo } from '..';
export const useGetInfoByGuid = (additionlInfo) => useQuery(['GetInfo', additionlInfo], () => trackPromise(getMigratorInfo(additionlInfo)), {
    cacheTime: 0,
});
